export const prefersReducedMotion = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function scrollToSection(id) {
    const target = document.getElementById(id);
    if (target && typeof target.scrollIntoView === "function") {
        target.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
    }
}

// Runs `callback` at most once per animation frame while the page scrolls or resizes.
export function subscribeToScroll(callback) {
    let frame = 0;
    const run = () => {
        frame = 0;
        callback();
    };
    const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(run);
    };

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    run();

    return () => {
        window.removeEventListener("scroll", schedule);
        window.removeEventListener("resize", schedule);
        if (frame) window.cancelAnimationFrame(frame);
    };
}
